// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/IntegrationConnection.yaml
// Generated: 2026-03-17T14:51:30.958Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateIntegrationConnection, UpdateIntegrationConnection, IntegrationConnection } from '@/types/integration/IntegrationConnection';

/**
 * IntegrationConnection Service
 * CRUD operations for IntegrationConnection via the ABP API.
 */
export const integrationConnectionService = new EntityService<IntegrationConnection, CreateIntegrationConnection, UpdateIntegrationConnection>(
  '/api/integration/integrationconnection',
  'IntegrationConnection',
);
